var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase } from "../../reactquestion_element";
import { ReactElementFactory } from "../../element-factory";
import { TitleElement } from "../title/title-element";
var SurveyHeader = /** @class */ (function (_super) {
    __extends(SurveyHeader, _super);
    function SurveyHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { changed: 0 };
        _this.rootRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyHeader.prototype, "survey", {
        get: function () {
            return this.props.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyHeader.prototype, "css", {
        get: function () {
            return this.survey.css;
        },
        enumerable: false,
        configurable: true
    });
    SurveyHeader.prototype.componentDidMount = function () {
        var self = this;
        this.survey.afterRenderHeader(this.rootRef.current);
        this.survey.locLogo.onChanged = function () {
            self.setState({ changed: self.state.changed + 1 });
        };
    };
    SurveyHeader.prototype.componentWillUnmount = function () {
        this.survey.locLogo.onChanged = function () { };
    };
    SurveyHeader.prototype.renderTitle = function () {
        if (!this.survey.renderedHasTitle)
            return null;
        var description = SurveyElementBase.renderLocString(this.survey.locDescription);
        return (React.createElement("div", { className: this.css.headerText, style: { maxWidth: this.survey.titleMaxWidth } },
            React.createElement(TitleElement, { element: this.survey }),
            this.survey.renderedHasDescription ? React.createElement("div", { className: this.css.description }, description) : null));
    };
    SurveyHeader.prototype.renderLogoImage = function (isRender) {
        if (!isRender)
            return null;
        var componentName = this.survey.getElementWrapperComponentName(this.survey, "logo-image");
        var componentData = this.survey.getElementWrapperComponentData(this.survey, "logo-image");
        return ReactElementFactory.Instance.createElement(componentName, {
            data: componentData,
        });
    };
    SurveyHeader.prototype.render = function () {
        if (!this.survey.renderedHasHeader)
            return null;
        return (React.createElement("div", { className: this.css.header, ref: this.rootRef },
            this.renderLogoImage(this.survey.isLogoBefore),
            this.renderTitle(),
            this.renderLogoImage(this.survey.isLogoAfter),
            React.createElement("div", { className: this.css.headerClose })));
    };
    return SurveyHeader;
}(React.Component));
export { SurveyHeader };
ReactElementFactory.Instance.registerElement("survey-header", function (props) {
    return React.createElement(SurveyHeader, props);
});
